<template>
  <div class="Pagecontainer">
    <div class="ModalDialog">
      <div class="DialogHead">
        <span>Confirmation Message</span>
      </div>
      <div class="DialogMessage">
        <span>{{Msg}}</span>
      </div>
      <div class="DialogAction">
        <button class="cancelBtn" @click="handleCancelClick">Cancel</button>
        <button @click="handleSubmitClick">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageDialog',
  data () {
    return {
      Msg: 'Do you really want to Submit Exam?'
    }
  },
  methods: {
    handleCancelClick: function () {
      this.$store.commit('setLoadDialog', {DialogLoad: false})
    },
    handleSubmitClick: function () {
      this.$store.commit('setSubmitExam', {SubmitSetter: true})
      this.$store.commit('setLoadDialog', {DialogLoad: false})
    }
  }
}
</script>
<style scoped>
.Pagecontainer {
  position: fixed;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  z-index: 10 !important;
}
.ModalDialog {
  height: 150px;
  width: 250px;
  background-color: white;
  text-align:left;
}
.DialogHead {
  height: 20px;
  font-size: 15px;
  color: white;
  background-color: #395693;
}
span {
  margin-left: 10px;
}
.DialogMessage {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60px;
  color: black;
  font-size:15px;
}
.DialogAction {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
}
.cancelBtn {
  background-color: #395693;
}
button {
  height: 30px;
  width: 60px;
  margin-left: 10px;
  margin-right: 10px;
  outline-style: none;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageDialog.vue